export default __webpack_public_path__ + "static/media/Vector_73.d183497e.svg";